import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { ItemAvatar } from "@opensea/next-ui-kit";
import { Tooltip } from "@opensea/ui-kit";
import { EnergySavingsLeaf, Offer, PromptSuggestion, Sell, ShoppingBag, StacksFilled, TraitOffer } from "@opensea/ui-kit/icons";
import { ActivityEvent } from "./ActivityEvent";
import { ActivityFeedTypeIconFragment } from "./ActivityFeedTypeIcon.fragment";
export function ActivityFeedTypeIcon(t0) {
  const $ = _c(14);
  const {
    activity: activityKey,
    size: t1
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[0] !== activityKey) {
    t2 = readFragment(ActivityFeedTypeIconFragment, activityKey);
    $[0] = activityKey;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const activity = t2;
  let t3;
  if ($[2] !== activity.__typename || $[3] !== size) {
    t3 = function renderAvatar() {
      switch (activity.__typename) {
        case "Sale":
          {
            return <ItemAvatar icon={ShoppingBag} size={size} />;
          }
        case "Transfer":
          {
            return <ItemAvatar icon={PromptSuggestion} size={size} />;
          }
        case "Mint":
          {
            return <ItemAvatar icon={EnergySavingsLeaf} size={size} />;
          }
        case "Listing":
          {
            return <ItemAvatar icon={Sell} size={size} />;
          }
        case "Offer":
          {
            return <ItemAvatar icon={Offer} size={size} />;
          }
        case "TraitOffer":
          {
            return <ItemAvatar icon={TraitOffer} size={size} />;
          }
        case "CollectionOffer":
          {
            return <ItemAvatar icon={StacksFilled} size={size} />;
          }
        default:
          {
            return null;
          }
      }
    };
    $[2] = activity.__typename;
    $[3] = size;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const renderAvatar = t3;
  let t4;
  if ($[5] !== activity) {
    t4 = <ActivityEvent activity={activity} />;
    $[5] = activity;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== renderAvatar) {
    t5 = renderAvatar();
    $[7] = renderAvatar;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div>{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <Tooltip content={t4}>{t6}</Tooltip>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}